import OurTeamSection from "./OurTeamSection";

export { OurTeamSection };
